import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Printer } from "lucide-react";
import { api } from "@/lib/api";
import { DocumentsUploader } from "@/components/DocumentsUploader";

export default function Documents() {
  const [p] = useSearchParams();
  const ref = p.get("ref") || "";
  const token = p.get("token") || "";
  return (
    <main className="mx-auto max-w-3xl px-5 pb-28 pt-36" data-testid="documents-page">
      <p className="eyebrow">Application {ref}</p>
      <h1 className="mt-4 font-display text-4xl font-semibold tracking-tight sm:text-5xl">Upload your documents.</h1>
      <p className="mt-4 text-slate-300">Files go straight to your private MidHq application file. Only our underwriting team can open them.</p>
      <div className="mt-10 border border-white/10 bg-[#0d1524] p-6 sm:p-8">
        {ref && token ? <DocumentsUploader reference={ref} token={token} /> : <p className="text-rose-300" data-testid="docs-missing-link">This upload link is incomplete. Use the link in your confirmation email.</p>}
      </div>
    </main>
  );
}

export function CreditAuthForm() {
  const [text, setText] = useState("");
  useEffect(() => {
    api.get("/credit-authorization-text").then((r) => setText(r.data?.text || "")).catch(() => setText(""));
  }, []);
  const Line = ({ label }) => (
    <div className="mt-8"><div className="h-px bg-black" /><p className="mt-1 text-xs text-gray-600">{label}</p></div>
  );
  return (
    <main className="min-h-screen bg-white px-6 pb-16 pt-28 text-black print:pt-6" data-testid="credit-form-page">
      <div className="mx-auto max-w-2xl">
        <button onClick={() => window.print()} className="mb-8 inline-flex items-center gap-2 rounded-full bg-black px-5 py-2.5 text-sm text-white print:hidden" data-testid="credit-form-print"><Printer className="h-4 w-4" /> Print / save as PDF</button>
        <p className="text-xs uppercase tracking-[0.2em] text-gray-500">MidHq · Merchant application</p>
        <h1 className="mt-2 text-3xl font-semibold">Credit Check Authorization</h1>
        <p className="mt-6 text-sm leading-relaxed">{text}</p>
        <div className="grid grid-cols-2 gap-x-8">
          <Line label="Business legal name" /><Line label="Application reference (MHQ-…)" />
          <Line label="Signer full legal name" /><Line label="Title" />
          <Line label="Signature" /><Line label="Date" />
        </div>
      </div>
    </main>
  );
}
